import React, { useContext } from "react";
import styled from "styled-components";
import { Box } from "reflexbox";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const TableWrapper = styled(Box)`
  border: 1px solid rgba(96, 113, 123, 0.3);
  border-radius: 12px;
  overflow: hidden;
  margin: 24px 0 40px !important;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

const Th = styled.th`
  padding: 14px 16px;
  text-align: left;
  color: ${colors.muted};
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  background: rgba(42, 199, 220, 0.06);
  border-bottom: 1px solid rgba(96, 113, 123, 0.3);
`;

const Td = styled.td`
  padding: 18px 16px;
  text-align: left;
  color: ${colors.text};
  font-size: 15px;
  line-height: 160%;
  border-bottom: 1px solid rgba(96, 113, 123, 0.7);

  &:first-child {
    color: ${colors.primaryGreen};
    font-weight: 500;
  }

  tr:last-child & {
    border-bottom: none;
  }
`;

const MobileCards = styled(Box)`
  display: none;
  margin: 24px 0;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileCard = styled(Box)`
  border: 1px solid rgba(96, 113, 123, 0.4);
  border-radius: 12px;
  padding: 6px 16px;
  margin-bottom: 16px !important;
`;

const MobileRow = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: baseline;
  padding: 12px 0;
  border-bottom: 1px solid rgba(96, 113, 123, 0.2);

  &:last-child {
    border-bottom: none;
  }
`;

const MobileLabel = styled(Box)`
  flex: 0 0 40%;
  max-width: 140px;
  font-size: 11px;
  font-weight: 600;
  color: ${colors.muted};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const MobileValue = styled(Box)`
  flex: 1;
  min-width: 0;
  font-size: 15px;
  color: ${(props) => (props.$isDeviceName ? colors.primaryGreen : colors.text)};
  font-weight: ${(props) => (props.$isDeviceName ? 500 : 400)};
  line-height: 150%;
  word-wrap: break-word;
`;

export function GuideTable({ headers, rows }) {
  const crownPrice = useContext(CrownPriceContext);
  const opts = { crownPrice };
  if (!headers || !rows) return null;

  return (
    <>
      <TableWrapper>
        <StyledTable>
          <thead>
            <tr>
              {headers.map((header, i) => (
                <Th key={i}>{parseMarkdownLinks(header, opts)}</Th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <Td key={j}>{parseMarkdownLinks(cell, opts)}</Td>
                ))}
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </TableWrapper>

      <MobileCards>
        {rows.map((row, i) => (
          <MobileCard key={i}>
            {row.map((cell, j) => (
              <MobileRow key={j}>
                <MobileLabel>{parseMarkdownLinks(headers[j], opts)}</MobileLabel>
                <MobileValue $isDeviceName={j === 0}>
                  {parseMarkdownLinks(cell, opts)}
                </MobileValue>
              </MobileRow>
            ))}
          </MobileCard>
        ))}
      </MobileCards>
    </>
  );
}
